import request from '@/utils/request'

export function getLuckyDrawList(data) {
  return request({
    url: 'api/v1/lucky-draw/getList',
    method: 'get',
    params: data
  })
}

export function getCateList(data) {
  return request({
    url: 'api/v1/lucky-draw/getCateList',
    method: 'get',
    params: data
  })
}

export function getRewardType(data) {
  return request({
    url: 'api/v1/lucky-draw/getRewardType',
    method: 'post',
    data: data
  })
}

export function updateLuckyDraw(data) {
  return request({
    url: 'api/v1/lucky-draw/updateList',
    method: 'post',
    data: data
  })
}

export function delLuckyDraw(data) {
  return request({
    url: 'api/v1/lucky-draw/delete',
    method: 'delete',
    data: data
  })
}
